// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3gyDA","modalForm":"UpgradeEpcsModal_modalForm__1yywn","modalFooter":"UpgradeEpcsModal_modalFooter__2pcFc"};